import styled from "styled-components";

export const TitleH1 = styled.h1`
  text-align: center;
  font-size: 54px;
  font-weight: 600;
  position: relative;
`;

export const SpanDescription = styled.strong`
  font-size: 26px;
  font-weight: 500;
  text-align: center;
`;

export const SpanDescriptionBold = styled.strong`
  font-size: 26px;
  font-weight: 700;
  text-align: center;
`;
